namespace SorAraBul.Definitions {
    export interface CurrenciesRow {
        Id?: number;
        CurrencyCode?: string;
        Name?: string;
        Symbol?: string;
        InsertDate?: string;
        InsertUserId?: number;
        UpdateDate?: string;
        UpdateUserId?: number;
        IsActive?: number;
        LookupName?: string;
    }

    export namespace CurrenciesRow {
        export const idProperty = 'Id';
        export const isActiveProperty = 'IsActive';
        export const nameProperty = 'Name';
        export const localTextPrefix = 'Definitions.Currencies';
        export const lookupKey = 'Definitions.Currencies';

        export function getLookup(): Q.Lookup<CurrenciesRow> {
            return Q.getLookup<CurrenciesRow>('Definitions.Currencies');
        }
        export const deletePermission = 'Administration:SuperAdmin';
        export const insertPermission = 'Administration:SuperAdmin';
        export const readPermission = 'Administration:SuperAdmin';
        export const updatePermission = 'Administration:SuperAdmin';

        export declare const enum Fields {
            Id = "Id",
            CurrencyCode = "CurrencyCode",
            Name = "Name",
            Symbol = "Symbol",
            InsertDate = "InsertDate",
            InsertUserId = "InsertUserId",
            UpdateDate = "UpdateDate",
            UpdateUserId = "UpdateUserId",
            IsActive = "IsActive",
            LookupName = "LookupName"
        }
    }
}
